module.exports = __webpack_public_path__ + "media/images/users/information_provided_to_client_companies.en-3a21b94f35e8a10f534c04783c27538c.png";